import * as React from "react";
import { BaseSyntheticEvent, ChangeEvent, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import {
  Radio,
  RadioGroup,
  TextField,
  FormControl,
  FormControlLabel,
  FormLabel,
  Autocomplete,
  Button,
  Checkbox,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import { useForm, Controller, FieldValues, set } from "react-hook-form";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { getApiCall, postApiCall } from "../../../services/apiHelper";
import { TaskmgmtServiceURL } from "../../../config/config";
import { ServiceName } from "../../../constants";
import { styled } from "@mui/system";
import { getProfile } from "../../../services/userContext";
import { UserContext } from "../../../redux/slices/userContextSlice";
import { RegionOptions } from "../../../constants";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { CurrentUser } from "../../../redux/slices/currentUserSlice";
import "./UserRoleMapDashboard.css";
import { wait } from "@testing-library/user-event/dist/utils";
import { ToastMessage } from "../../util/ToastMessage";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export class UserRole {
  id!: number;
  UserName!: string;
  UserID!: string;
  UserType!: string;
  Email!: string;
  role!: string;
  OldRole!: string;
  FundId!: string;
  FundName!: string;
  InvestmentType!: string;
  Region!: string;
  Status!: string;
  Firm!: string;
  FirstName!: string;
  LastName!: string;
  createdBy!: string;
  created!: string;
  lastModifiedBy!: string;
  lastModified!: string;
  ShowDelete: boolean = false;
  IsDeletedAndArchivedRole: boolean = false;
}

export const UserRoleMapFormNew = () => {
  const navigate = useNavigate();
  const params = useParams();
  const page = params.page;
  const userId = params.userRoleId;
  const Label = styled("label")({
    display: "block",
  });
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();
  const anyFund = [{ fundId: "Any", fundName: "Any" }];
  const [isError, setIsError] = useState<{ isError: boolean; message: string }>(
    { isError: false, message: "" }
  );
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedRole, setSelectedRole] = useState<any>();
  const [selectedRegion, setSelectedRegion] = useState<any[]>([]);
  const [funds, setFunds] = useState<any[]>([]);
  const [users, setUsers] = useState<any[]>([]);
  const [isShow, setIsShow] = useState<boolean>(false);
  const [userType, setUserType] = useState<string>("Internal");
  const [selectedFunds, setSelectedFunds] = useState<any[]>([]);
  const [selectedUser, setSelectedUser] = useState<any>();
  const [filteredFunds, setFilteredFunds] = useState<any[]>([]);
  const [filteredRoles, setFilteredRoles] = useState<any[]>([]);
  const [selectedUserEmail, setSelectedUserEmail] = useState<string>("");
  const [regionList, setRegionList] = useState<any[]>(RegionOptions);
  const [roles, setRoles] = useState<any[]>([]);
  const [status, setStatus] = useState<string>("Active");
  const [selectedInvestmentType, setSelectedInvestmentType] = useState<any[]>(
    []
  );

  const anyFundArray:any[] = [{
    key: 2000,
    label: "Any",
    value: {
        id: 2000,
        fundID: "Any",
        fundName: "Any",
        region: "US",
        createdBy: "",
        created: "",
        lastModifiedBy: "",
        lastModified: ""
    },
    region: [
        "US","APAC","APAC"
    ]
}];

  const currentUserData: CurrentUser = useAppSelector(
    (state) => state.currentUser.data
  );
  const userRoleMap = new UserRole();
  useEffect(() => {
    getAllRecords();
  }, []);

  const getAllRecords = async () => {
    try {
      setLoading(true);
      await getApiCall(
        TaskmgmtServiceURL + "/userrolemaps/UserGetAll",
        ServiceName.TASKMANAGEMENTSERVICE
      )
        .then((users: any) => {
          var userArr: any[] = [];
          userArr = users?.result.map((user: any, index: any) => {
            return {
              label: user.firstName + " " + user.lastName,
              value: user,
            };
          });
          const uniqueOptions = Array.from(
            new Set(userArr.map((a) => a.label))
          ).map((label) => {
            return userArr.find((a) => a.label === label);
          });
          console.log(uniqueOptions);

          setUsers(uniqueOptions);
        })
        .catch((e) => console.log(e));

      await getApiCall(
        TaskmgmtServiceURL + "/Funds/getall",
        ServiceName.TASKMANAGEMENTSERVICE
      )
        .then((funds: any) => {
          var fundArr: any[] = [];
          fundArr = funds?.result.map((fund: any) => {
            return {
              key: fund.id,
              label: fund.fundName,
              value: fund,
              region: fund.region != null ? fund.region.split(";") : [],
            };
          });
          const uniqueOptions = Array.from(
            new Set(fundArr.map((a) => a.label))
          ).map((label) => {
            return fundArr.find((a) => a.label === label);
          });

          anyFundArray.forEach((data:any) => {
            uniqueOptions.push(data);
          })


          setFunds(uniqueOptions);
        })
        .catch((e) => console.log(e));

      await getApiCall(
        TaskmgmtServiceURL + "/Roles/getall",
        ServiceName.TASKMANAGEMENTSERVICE
      )
        .then((roles: any) => {
          var roleArr: any[] = [];
          roleArr = roles?.result.map((item: any) => {
            return {
              label: item.role,
              value: item.role,
              region: item.region != null ? item.region.split(";") : [],
            };
          });
          const uniqueOptions = Array.from(
            new Set(roleArr.map((a) => a.label))
          ).map((label) => {
            return roleArr.find((a) => a.label === label);
          });
          setRoles(uniqueOptions);
        })
        .catch((e) => console.log(e));
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const handleRoleDetailChange = (role: any) => {
    console.log(role);
    if (
      role != null &&
      (role.value.toLowerCase() === "admin" ||
        role.value.toLowerCase() === "audit" ||
        role.value.toLowerCase() === "asset management")
    ) {
      setSelectedFunds(anyFund);
      setSelectedInvestmentType(investmentType);
      setIsShow(false);
    } else if (!role) {
      setIsShow(false);
    } else {
      setIsShow(true);
    }
    setSelectedRole(role);
  };

  //Function to change Roles or Funds according region. argument property represents fund or role
  const fnCheckAllowed = (property: any, regions: any) => {
    var flag = false;

    regions.forEach((region: any) => {
      if (property.region.includes(region.label)) {
        flag = true;
        return true;
      }
    });

    return flag;
  };

  const handelRegionChange = (regions: any) => {
    console.log(regions);

    //sort the region array
    setSelectedRegion(
      regions.sort((a: any, b: any) => a.value.localeCompare(b.value)).reverse()
    );

    //Function to change Funds according region.
    var filteredFunds = funds.filter((fund: any) =>
      fnCheckAllowed(fund, regions)
    );

    //Function to change Roles according region.
    var filteredRoles = roles.filter((role: any) =>
      fnCheckAllowed(role, regions)
    );
    console.log(filteredFunds);
    console.log(filteredRoles);

    setFilteredFunds(filteredFunds);
    setFilteredRoles(filteredRoles);
  };

  const handleSelectedUserChange = (user: any) => {
    console.log(user);
    setSelectedUser(user);
    //set email on change of user
    setSelectedUserEmail(user?.value.email);
  };

  const handelFundsChange = (funds: any) => {
    var selectedFund = funds
      .map((fund: any) => {
        return { fundId: fund.value.fundID, fundName: fund.value.fundName };
      })
      .sort((a: any, b: any) => a.fundId.localeCompare(b.fundId));
    console.log(selectedFund);
    setSelectedFunds(selectedFund);
  };

  const investmentType = ["Equity", "Debt Asset", "Debt Liability", "Mortgage"];

  const handleUserTypeChange = (
    event: ChangeEvent<HTMLInputElement>,
    value: string
  ): void => {
    setUserType(value);
  };

  const handleStatusChange = (
    event: ChangeEvent<HTMLInputElement>,
    value: string
  ): void => {
    setStatus(value);
  };

  const handleInvestmentTypeChange = (value: any): void => {
    console.log(value);
    setSelectedInvestmentType(value.sort());
  };

  const SubmitUserRoleMap = (
    data: FieldValues,
    event?: BaseSyntheticEvent<object, any, any> | undefined
  ) => {
    userRoleMap.FundId = selectedFunds.map((fund) => fund.fundId).join(";");
    userRoleMap.FundName = selectedFunds.map((fund) => fund.fundName).join(";");
    userRoleMap.InvestmentType = selectedInvestmentType
      .map((type: any) => type)
      .join(";");
    userRoleMap.Region = selectedRegion.map((region) => region.label).join(";");
    userRoleMap.role = selectedRole.label;
    userRoleMap.UserName = selectedUser.label;
    userRoleMap.FirstName = selectedUser.value.firstName;
    userRoleMap.LastName = selectedUser.value.lastName;
    userRoleMap.UserID = selectedUserEmail;
    userRoleMap.Email = selectedUserEmail;
    userRoleMap.UserType = userType;
    userRoleMap.createdBy =
      currentUserData.email == undefined ? "" : currentUserData.email;
    userRoleMap.Firm =
      userType == "Internal" ? "TIAA" : selectedUser.value.firm;
    userRoleMap.Status = status;
    try {
      setLoading(true);
      postApiCall(
        TaskmgmtServiceURL + "/userrolemaps/save",
        userRoleMap,
        ServiceName.TASKMANAGEMENTSERVICE
      )
        .then((res: any) => {
          setIsSuccess(true);
          wait(3000).then(() => {
            navigate("/userrolemap/list");
          });
        })
        .catch((error: any) => {
          console.log(error);
          setIsError({
            isError: true,
            message: error.response.data.responseException.exceptionMessage,
          });
        });
    } catch (error) {
      console.log(error);
    } finally {
      wait(1000).then(() => {
        setLoading(false);
      });
      setIsError({ isError: false, message: "" });
      setIsSuccess(false);
    }
  };

  return (
    <div className="form-wrap">
      <Box sx={{ width: "100%", typography: "body1" }}>
        {loading && (
          <div className="overlaySpinner">
            <CircularProgress />
          </div>
        )}
        {isSuccess && (
          <ToastMessage message="User Role map is submitted" severity="success" />
        )}
        {isError.isError && (
          <ToastMessage message={isError.message} severity="error" />
        )}
        <Grid container spacing={3}>
          <Grid item xs={6} sm={6}>
            <Controller
              name="Region"
              control={control}
              rules={{ required: "Region is required." }}
              render={({ field, fieldState: { error } }) => (
                <Autocomplete
                  multiple
                  aria-label="Region_test"
                  id="checkboxes-tags-demo"
                  options={regionList}
                  value={selectedRegion}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option.label}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option.label}
                    </li>
                  )}
                  onChange={(event, value) => {
                    field.onChange(value);
                    handelRegionChange(value);
                  }}
                  // style={{ width: 500 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Region"
                      size="small"
                      fullWidth
                      error={!!error}
                      placeholder="Selece region"
                      required
InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
                    />
                  )}
                />
              )}
            />
          </Grid>

          <Grid item xs={6} sm={6}>
            <Controller
              name="roles"
              control={control}
              rules={{ required: "roles is required." }}
              render={({ field, fieldState: { error } }) => (
                <Autocomplete
                  id="userRoleList"
                  aria-label="Role"
                  disabled={selectedRegion.length == 0}
                  options={filteredRoles}
                  // value={selectedRole}
                  readOnly={false}
                  onChange={(event, value) => {
                    field.onChange(value);
                    handleRoleDetailChange(value);
                  }}
                  getOptionLabel={(option) => option.label}
                  renderInput={(params) => (
                    <Tooltip
                      title={
                        selectedRegion.length === 0
                          ? "First select Region"
                          : ""
                      }
                      placement="top-start"
                      arrow
                    >
                      <TextField
                        {...params}
                        label="Role"
                        error={!!error}
                        size="small"
                        fullWidth
                        placeholder="Select Role"
                        required
InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
                      />
                    </Tooltip>
                  )}
                />
              )}
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <Controller
              name="user"
              control={control}
              rules={{ required: "User is required." }}
              render={({ field, fieldState: { error } }) => (
                <Autocomplete
                  id="user"
                  // disabled={selectedRegion.length == 0}
                  options={users}
                  getOptionLabel={(option) => option.label}
                  onChange={(event, value) => {
                    field.onChange(value);
                    handleSelectedUserChange(value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="User"
                      error={!!error}
                      size="small"
                      fullWidth
                      placeholder="Select Role"
                      required
InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
                    />
                  )}
                  disableClearable
                />
              )}
            />
          </Grid>

          <Grid item xs={6} sm={6}>
            <TextField
              label="Email"
              size="small"
              className="Autopopulatefield"
              value={selectedUserEmail}
              // InputProps={{
              //   readOnly: true,
              // }}
              variant="outlined"
              fullWidth
            />
          </Grid>

          <Grid item xs={6} sm={6}>
            <FormControl
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <FormLabel id="row-radio-buttons-group-label" >
                User Type
              </FormLabel>
              <RadioGroup
                row
                style={{ marginLeft: "25px" }}
                aria-labelledby="row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={userType}
                onChange={handleUserTypeChange}
              >
                <FormControlLabel
                  value="Internal"
                  control={<Radio />}
                  label="Internal"
                />
                <FormControlLabel
                  value="External"
                  control={<Radio />}
                  label="External"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={6}>
            <FormControl
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <FormLabel id="row-radio-buttons-group-label">Status</FormLabel>
              <RadioGroup
                row
                style={{ marginLeft: "25px" }}
                aria-labelledby="row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={status}
                onChange={handleStatusChange}
              >
                <FormControlLabel
                  value="Active"
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel
                  value="InActive"
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          {isShow && (
            <Grid item xs={6} sm={6}>
              <Controller
                name="Fund"
                control={control}
                rules={{ required: "Fund is required." }}
                render={({ field, fieldState: { error } }) => (
                  <Autocomplete
                    multiple
                    // className={(selectedFunds.length == 0) ? 'redBorder':''}
                    id="checkboxes-tags-demo"
                    options={filteredFunds}
                    disableCloseOnSelect
                    disabled={selectedRegion.length === 0}
                    getOptionLabel={(option) => option.label}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.label}
                      </li>
                    )}
                    onChange={(event, value) => {
                      field.onChange(value);
                      handelFundsChange(value);
                    }}
                    // style={{ width: 500 }}
                    renderInput={(params) => (
                      <Tooltip
                        title={
                          selectedRegion.length === 0
                            ? "To edit funds first select Region"
                            : ""
                        }
                        placement="top-start"
                        arrow
                      >
                        <TextField
                          label="Fund(s)"
                          {...params}
                          size="small"
                          fullWidth
                          error={!!error}
                          required
InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
                          placeholder="Fund(s)"
                        />
                      </Tooltip>
                    )}
                  />
                )}
              />
              {/* {errors.Fund && <span className="error-message">{errors.Fund.message?.toString()}</span>} */}
            </Grid>
          )}
          {isShow && (
            <Grid item xs={6} sm={6}>
              <Controller
                name="Investment Type"
                control={control}
                rules={{ required: "Investment Type is required." }}
                render={({ field, fieldState: { error } }) => (
                  <Autocomplete
                    multiple
                    id="checkboxes-tags-demo"
                    options={investmentType}
                    disabled={selectedRegion.length === 0}
                    disableCloseOnSelect
                    getOptionLabel={(option) => option}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option}
                      </li>
                    )}
                    onChange={(event, value) => {
                      field.onChange(value);
                      handleInvestmentTypeChange(value);
                    }}
                    // style={{ width: 500 }}
                    renderInput={(params) => (
                      <Tooltip
                        title={
                          selectedRegion.length === 0
                            ? "To edit investment types first select Region"
                            : ""
                        }
                        placement="top-start"
                        arrow
                      >
                        <TextField
                          label="Investment Type(s)"
                          {...params}
                          error={!!error}
                          size="small"
                          fullWidth
                          placeholder="Investment Type(s)"
                          required
InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
                        />
                      </Tooltip>
                    )}
                  />
                )}
              />
            </Grid>
          )}
          <Grid item xs={12} sm={12}>
            <Button sx={{textTransform:"none"}}
              disabled={isError.isError || isSuccess}
              variant="contained"
              size="medium"
              color="success"
              type="submit"
              onClick={handleSubmit(SubmitUserRoleMap)}
            >
              Submit
            </Button>
            <Button 
              variant="outlined"
              size="medium"
              color="error"
              sx={{ ml: 2 }}
              onClick={() => navigate("/userrolemap/list")}
            >
              Cancel
            </Button>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};
